import React, { useEffect, useState } from "react";
import { Outlet } from "react-router-dom";
import Header from "./Header";
import Footer from "./Footer";
import FloatingContact from "../common/FloatingContact";
import CookieBanner from "../common/CookieBanner";
import api from "../../lib/api";

/* Hydrate immediately from localStorage cache so first paint isn't a flicker of
   placeholders (empty logo / fallback contact form / etc.). Cache has a short
   TTL so admin edits become visible almost immediately on the next visit — no
   stale logos or themes flashing before fresh data arrives. */
const CACHE_TTL_MS = 60 * 1000; // 60 seconds
const readCache = () => {
  try {
    const raw = localStorage.getItem("firat.settings.v1");
    if (!raw) return null;
    const { data, ts } = JSON.parse(raw);
    if (!data || typeof data !== "object") return null;
    if (typeof ts !== "number" || Date.now() - ts > CACHE_TTL_MS) return null;
    return data;
  } catch {
    return null;
  }
};

const SiteLayout = () => {
  const cached = readCache();
  const [settings, setSettings] = useState(cached);
  useEffect(() => {
    api
      .get("/public/settings")
      .then((r) => {
        const data = r.data || {};
        setSettings(data);
        try {
          localStorage.setItem(
            "firat.settings.v1",
            JSON.stringify({ data, ts: Date.now() })
          );
        } catch { /* quota */ }
      })
      .catch(() => setSettings((prev) => prev || {}));
  }, []);
  const ready = settings !== null;
  const s = settings || {};
  return (
    <div className="min-h-screen bg-white flex flex-col">
      <Header settings={s} ready={ready} />
      <main className="flex-1">
        <Outlet context={{ settings: s, ready }} />
      </main>
      {ready ? <Footer settings={s} /> : null}
      {ready ? <FloatingContact settings={s} /> : null}
      <CookieBanner />
    </div>
  );
};

export default SiteLayout;
